export default {
    login: {
      url: "/api/v2/login/auth"
    },
    gallery: {
      url: "/api/v2/photo/list"
    },
    sensor: {
      url: "/api/v2/sensor/lasthours"
    },
    timestamps: {
      url: "/api/v2/sensor/timestamps"
    },    
    latest: {
      url: "/api/v2/sensor/latest"
    },
    subscriptionCreate: {
      url: "/api/v2/subscription/create"
    },
    insect: {
      url: "/api/v2/insect/intensity"
    },
  };
  